import React, {useEffect} from 'react'
import Grid from '@mui/material/Grid'
import WbButton from '../../components/common/WbButton'
import usePupilData from '../../hooks/usePupilData'
import {CircularProgress} from '@mui/material'
import {useNavigate} from 'react-router-dom'
import paths from '../../routes/paths'
import checkinApi from '../../services/api/checkin/checkinApi'
import {checkInCadenceSentence, nextCheckInSentence} from './checkInCadence'

export default function CheckIn() {
  const [loading, setLoading] = React.useState(false)
  const [checkInAvailability, setCheckInAvailability] = React.useState(false)

  const pupil = usePupilData()
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    checkinApi
      .CheckInAvailableForPupil(pupil.schoolId, pupil.groupId, pupil.studentId)
      .then(res => setCheckInAvailability(res))
      .catch(error => {
        // Previously unhandled. A failed request left availability false, so a pupil whose check-in
        // could not be looked up saw the same screen as a pupil who genuinely has none - which is
        // how this went unnoticed while the request was being sent with the wrong parameter name.
        console.error(
          'Could not check whether a check-in survey is available',
          error
        )
        setCheckInAvailability(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const nextCheckIn = nextCheckInSentence(checkInAvailability.nextLaunchDate)

  return loading ? (
    <CircularProgress></CircularProgress>
  ) : checkInAvailability.available ? (
    <Grid item lg={6} md={6} sm={12} xs={12}>
      <div className="my-checkin-surveys">
        <h1>
          <b>My Check-In Surveys</b>
        </h1>
        <p>{checkInCadenceSentence(checkInAvailability.frequency)}</p>
        {checkInAvailability.hasSubmitted ? (
          <>
            <h3 style={{marginTop: '12px'}}>
              Submitted on:{' '}
              {new Date(checkInAvailability.submitedDate).toDateString()}
            </h3>
            {nextCheckIn && <p>{nextCheckIn}</p>}
          </>
        ) : (
          <WbButton
            CustomButtonText={'Start Check-In'}
            style={{
              backgroundColor: '#45338C',
              border: 'none',
              fontSize: '20px',
              marginTop: '12px',
            }}
            onClick={() => navigate(paths.checkinQuestionaire)}
          />
        )}
        <div className="safespace-bottom">
          Your answers help your school understand how you are feeling. If you
          choose one of the two lowest answers, you can start a Safe Space
          conversation with a member of staff.
        </div>
      </div>
    </Grid>
  ) : (
    ''
  )
}
